<app-integer-control
	[label]="label()"
	[controlName]="controlName()"
	[placeholder]="placeholder()"
	[required]="required()"
	[min]="min()"
	[max]="max()"
	[disabled]="disabled()"
	[formGroup]="formGroup()"
/>
